export default "__VITE_ASSET__ff385f1b__"